export default "__VITE_ASSET__DDwAjWhE__"